<template>
    <div class="account-pages my-5 pt-5">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-10 col-xl-10">
                    <div class="card overflow-hidden">
                        <div class="bg-soft bg-white border-bottom" style="border-color:#b7b7b7!important">
                            <div class="row">
                                <div class="col-7">
                                    <div class="text-primary p-4" v-if="ready">
                                        <h2 class="text-primary">Analysis Request - {{ requestData.client_name }}</h2>
                                        <h5><strong>Type:</strong> {{ requestData.type }}</h5>
                                        <h5><strong>Sample Name:</strong> {{ requestData.sample_name }}</h5>
                                        <h5><strong>Net Mass (g):</strong> {{ requestData.net_mass }}</h5>
                                        <h5><strong>Date Packaged:</strong> {{ requestData.packaged_date }}</h5>
                                        <h5><strong>Sample Trace ID:</strong> {{ requestData.sample_tag_id }}</h5>
                                    </div>
                                </div>
                                <div class="col-5 align-self-end">
                                    <img src="@/assets/ccb_fixed_logo.png" alt class="img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div class="card-body pt-0">
                            <div class="p-2">
                                <div class="form-horizontal">
                                    <div class="col-sm-10">
                                        <b-form>
                                            <b-form-group class="mb-4" label="Lab User Name: " label-for="lab-user-name" label-cols-sm="3">
                                                <b-form-input id="lab-user-name" type="text" v-model="postdata.lab_user_name"></b-form-input>
                                            </b-form-group>

                                            <b-form-group class="mb-4" label="Lab User Email: " label-for="lab-user-email" label-cols-sm="3">
                                                <b-form-input id="lab-user-email" type="email" v-model="postdata.lab_user_email"></b-form-input>
                                            </b-form-group>

                                            <b-form-group class="mb-4" label="COA Number: " label-for="coa-no" label-cols-sm="3">
                                                <b-form-input id="coa-no" type="text" v-model="postdata.coa_number"></b-form-input>
                                            </b-form-group>

                                            <b-form-group class="mb-4" label="Notes: " label-for="notes" label-cols-sm="3">
                                                <b-form-textarea id="notes" v-model="postdata.notes" placeholder="Add optional notes here" rows="3" max-rows="6"></b-form-textarea>
                                            </b-form-group>

                                            <!-- New Toggle for Test Result -->
                                            <b-form-group class="mb-4" label="Test Result: " label-cols-sm="3">
                                                <b-form-checkbox v-model="postdata.test_passed" switch>
                                                    &nbsp;{{ postdata.test_passed ? 'Tests Passed' : 'Tests Failed' }}
                                                </b-form-checkbox>
                                            </b-form-group>

                                            <!-- Conditional Textarea for Failure Reason -->
                                            <b-form-group v-if="!postdata.test_passed" class="mb-4" label="Failure Reason: " label-for="failure-reason" label-cols-sm="3">
                                                <b-form-textarea id="failure-reason" v-model="postdata.failure_reason" placeholder="Provide reason for failure" rows="3" max-rows="6"></b-form-textarea>
                                            </b-form-group>
                                        </b-form>

                                        <uploader :options="renderUploadOptions()" :autoStart="false" :ref="'attach_upload'" class="uploader-example">
                                            <uploader-unsupport></uploader-unsupport>
                                            <uploader-drop>
                                                <p>Drop COA here to upload or</p>
                                                <uploader-btn type="button" :single="false"><i class="fas fa-file fa-fw"></i> Select file</uploader-btn>&nbsp;
                                            </uploader-drop>
                                            <uploader-list></uploader-list>
                                        </uploader>
                                    </div>

                                    <div class="col-sm-6 offset-sm-3 mt-4 d-grid">
                                        <button class="btn btn-primary" type="submit" @click="saveSampleData()">Submit</button>
                                    </div>

                                    <div class="mt-4 text-center">
                                        <p class="mb-0">© {{ new Date().getFullYear() }} CCB IT</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-overlay :show="requestComplete" no-wrap>
                            <template #overlay>
                                <div class="text-center">
                                    <i style="font-size: 4rem; color: green;" class="fas fa-check-circle"></i>
                                    <h2>Results Submitted</h2>
                                    <h2>Thank You</h2>
                                </div>
                            </template>
                        </b-overlay>

                        <b-overlay :show="!tokenValid" no-wrap>
                            <template #overlay>
                                <div class="text-center">
                                    <i style="font-size: 4rem; color: red;" class="fas fa-exclamation-triangle"></i>
                                    <h2 id="cancel-label">Token Expired</h2>
                                </div>
                            </template>
                        </b-overlay>

                        <b-overlay :show="!ready" no-wrap></b-overlay>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';

export default {
    page: {
        title: "Analysis Request",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            ready: false,
            requestComplete: false,
            tokenValid: true,
            requestData: [],
            postdata: {
                lab_user_name: "",
                lab_user_email: "",
                coa_number: "",
                notes: "",
                test_passed: true,
                failure_reason: ""
            }
        };
    },
    methods: {
        fetchRequestData() {
            this.ready = false;
            axios.get('api/ext/samplerequest/' + this.$route.params.token)
                .then(response => {
                    this.requestData = response.data;
                    this.postdata.lab_user_name = this.requestData.recipient_name;
                    this.postdata.lab_user_email = this.requestData.recipient_emails;
                    this.ready = true;
                })
                //eslint-disable-next-line no-unused-vars
                .catch(e => {
                    this.tokenValid = false;
                    this.ready = true;
                });
        },
        saveSampleData() {
            if (this.postdata.lab_user_name === "" || this.postdata.lab_user_email === "") {
                Swal.fire("Error", "Please check the form!", "error");
                return;
            }

            this.ready = false;
            const uploaderInstance = this.$refs['attach_upload'];
            const upload = uploaderInstance.uploader;
            upload.opts.query.lab_user_name = this.postdata.lab_user_name;
            upload.opts.query.lab_user_email = this.postdata.lab_user_email;
            upload.opts.query.coa_number = this.postdata.coa_number;
            upload.opts.query.notes = this.postdata.notes;
            upload.opts.query.tests_passed = (this.postdata.test_passed ? 1 : 0);
            upload.opts.query.fail_reason = this.postdata.test_passed ? "" : this.postdata.failure_reason;

            upload.resume();
            //eslint-disable-next-line no-unused-vars
            upload.on('fileSuccess', (rootFile, file, message, chunk) => {
                var response = JSON.parse(message);
                if (response.success) {
                    this.ready = true;
                    this.requestComplete = true;
                    upload.off("fileSuccess");
                    upload.cancel();
                } else {
                    Swal.fire("Error", "Please contact support!", "error");
                }
            });
        },
        renderUploadOptions() {
            var url = process.env.VUE_APP_API_BASEURL + 'api/ext/uploadcoa';
            return {
                target: url,
                query: {
                    token: this.$route.params.token,
                    lab_user_name: "",
                    lab_user_email: "",
                    coa_number: "",
                    notes: "",
                    test_passed: true,
                    failure_reason: ""
                },
                testChunks: false,
                withCredentials: true,
                fileParameterName: 'coa',
                singleFile: true
            };
        }
    },
    mounted() {
        this.fetchRequestData();
    }
};
</script>
